import React from "react";
import { Box, Typography, CircularProgress, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

const PendingIndicator = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 16,
  right: 16,
  backgroundColor: theme.palette.warning.main,
  color: theme.palette.warning.contrastText,
  padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  zIndex: 1300,
  boxShadow: theme.shadows[6],
  animation: "pulse 2s infinite",
  "@keyframes pulse": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0.7 },
    "100%": { opacity: 1 },
  },
}));

interface CartPendingIndicatorProps {
  pendingCount: number;
  isVisible: boolean;
}

/**
 * Visual indicator for pending cart operations
 * Shows users when operations are in progress and might be lost on page refresh
 */
export const CartPendingIndicator: React.FC<CartPendingIndicatorProps> = ({
  pendingCount,
  isVisible,
}) => {
  if (!isVisible || pendingCount === 0) return null;

  return (
    <PendingIndicator>
      <CircularProgress size={16} color="inherit" />
      <Typography variant="body2" fontWeight="medium">
        {pendingCount} cambio{pendingCount > 1 ? "s" : ""} pendiente
        {pendingCount > 1 ? "s" : ""}
      </Typography>
      <Chip
        label="Guardando..."
        size="small"
        color="default"
        sx={{ backgroundColor: "rgba(255,255,255,0.2)" }}
      />
    </PendingIndicator>
  );
};

export default CartPendingIndicator;
